import { Form, InputOnChangeData } from "semantic-ui-react";
import { FormError } from "../models/FormError";
import FileDropZone from "./common/FileDropZone";
import UserFiles from "./common/UserFiles";
import { UserFile } from "../models/UserFile";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { useAppContext } from "../hooks/useAppContext";

export interface FormData {
  title: string;
  expiryDate: Date;
  userFile?: UserFile;
}

interface Props {
  formData: FormData;
  formErrors: FormError;
  onChange: (formData: FormData) => void;
  onAcceptedFilesSelected: (userFiles: UserFile[]) => void;
  onRejectedFilesSelected: (userFiles: UserFile[]) => void;
}

const AddOrgUserFileForm = ({
  formData,
  formErrors,
  onChange,
  onAcceptedFilesSelected,
  onRejectedFilesSelected,
}: Props) => {
  const { documentMaxSizeByte } = useAppContext();

  const handleChange = (e: any, { name, value }: InputOnChangeData) => {
    onChange({ ...formData, [name]: value });
  };
  const onExpiryDateChange = (e: any, data: any) => {
    formData.expiryDate = data.value;
  };
  return (
    <>
      <Form>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>Title</label>
            <Form.Input error={formErrors.title} name="title" value={formData.title} onChange={handleChange} />
          </Form.Field>
          <SemanticDatepicker
            label="Expiry date"
            value={formData.expiryDate}
            locale="en-US"
            onChange={onExpiryDateChange}
            type="basic"
          />
        </Form.Group>

        <Form.Group widths="equal">
          <Form.Field>
            <label>File</label>
            {formErrors.userFile && (
              <span className="field error">
                <label>{formErrors.userFile}</label>
              </span>
            )}
            <FileDropZone
              maxSizeByte={documentMaxSizeByte}
              multiple={false}
              accept={[".pdf"]}
              onAcceptedFilesSelected={onAcceptedFilesSelected}
              onRejectedFilesSelected={onRejectedFilesSelected}
            />
          </Form.Field>
        </Form.Group>

        {formData.userFile && (
          <Form.Group widths="equal">
            <Form.Field>
              <UserFiles userFilesMap={new Map([[formData.userFile.id, formData.userFile]])} />
            </Form.Field>
          </Form.Group>
        )}
      </Form>
    </>
  );
};

export default AddOrgUserFileForm;
